import React from 'react';
import type { AdditionalLabelRenderProps, ServiceDetails } from '../../common/types/index.tsx';
import { ActiveIncidentsIndicator } from '../../common/ui/active-incidents-indicator/index.tsx';

export const AdditionalLabelContent = ({ values }: AdditionalLabelRenderProps<ServiceDetails>) => (
	<ActiveIncidentsIndicator services={values.map((value) => value.data)} />
);
